import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import PropTypes from "prop-types";
import StripeCardForm from "~/components/Subscription/BillingPaymentMethod/StripeCardForm";
import { getConfigOption } from "~/store/selectors/selector.configOptions";
import { getLanguageISO639_1 } from "~/store/selectors/selector.languages";
import { makeGetLoggedUserLanguageIdSelector } from "~/store/selectors/selector.users";

const StripeCardFromProvider = ({ onSubmit, onError, isValidated }) => {
  const stripeApiKey = useSelector((state) => getConfigOption(state, "stripe_api_key"));
  const stripePromise = useMemo(() => loadStripe(stripeApiKey), [stripeApiKey]);
  const getLoggedUserLanguageSelector = makeGetLoggedUserLanguageIdSelector();
  const loggedUserLanguageId = useSelector((state) => getLoggedUserLanguageSelector(state));

  const loggedUserLanguage = useSelector((state) => getLanguageISO639_1(state, loggedUserLanguageId));

  return (
    <Elements
      stripe={stripePromise}
      options={{ locale: loggedUserLanguage }}
    >
      <StripeCardForm
        onSubmit={onSubmit}
        onError={onError}
        isValidated={isValidated}
      />
    </Elements>
  );
};

StripeCardFromProvider.propTypes = {
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
  isValidated: PropTypes.func,
  stripeFormId: PropTypes.string,
};

StripeCardFromProvider.defaultProps = {
  stripeFormId: "stripe_form",
};

export default StripeCardFromProvider;
